<template>
    <b-table
      hover
      :table-class="[{'manage-table': true, 'border-bottom': !loading, 'border-top': borderTop}, tableClass]"
      :items="items"
      :fields="fieldsInternal"
      :busy="loading"
      @row-clicked="onRowClick"
      responsive
      show-empty
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template #table-busy>
        <div class="text-center">
          <b-spinner small/>
        </div>
      </template>

      <template #[`cell(${firstColumn})`]="{ item, value }">
        <router-link
          class="text-reset text-decoration-none"
          :to="getTo(item)"
        >
          {{value}}
        </router-link>
      </template>

      <!-- pass all slots from parent component -->
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope"/>
      </template>
    </b-table>
</template>

<script>
export default {
  name: 'ManageListTable',
  inheritAttrs: false,
  props: {
    items: Array,
    fields: Array,
    loading: Boolean,
    borderTop: { type: Boolean, default: true },
    tableClass: null,
    getTo: {
      type: Function,
      default(item) {
        return { path: String(item.id), append: true }
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    fieldsInternal() {
      const firstItem = this.items && this.items[0]
      if (!firstItem) { return this.fields }
      const populated = this.fields?.filter(i => Object.keys(firstItem).includes(i.key))
      // if no populated fields, derive fields from item
      return populated?.length ? this.fields : makeFields(firstItem)
    },
    firstColumn() {
      const fields = this.fieldsInternal
      if (!fields) { return }
      // get key of first non-image field
      const key = fields
        .map(i => i.key ?? i)
        .find(i => !['thumbnail', 'preview'].includes(i))
      return key
    },
  },
  methods: {
    onRowClick(item, index, event) {
      if (event.ctrlKey || event.metaKey || event.shiftKey) {
        const routeData = this.$router.resolve(this.getTo(item))
        window.open(routeData.href, '_blank')
      } else {
        this.$router.push(this.getTo(item))
      }
    },
  },
}

function makeFields(object) {
  return Object.keys(object)
    .map((key, idx) => {
      const append = idx
        ? {autoshow: 'sm'}
        : null
      return {key, ...append}
    })
}
</script>

<style lang="scss" scoped>
/deep/ .manage-table {
  thead th {
    border-top: none;
    padding-bottom: (($table-cell-padding / 1rem * 16px) - $table-border-width);
    white-space: nowrap;
  }
  tbody tr:not(.b-table-empty-row):not(.b-table-busy-slot) {
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
